import React from 'react';
import PropTypes from 'prop-types';
import RenderCategoriesInputField from 'components/form/InputFields/AutoCompleteField/RenderCategoriesInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';

class SubcategoriesCreateForm extends React.Component {
    render() {
        const {
            form,
            invalid,
            handleSubmit,
            handleSubmitForm,
            pristine,
            submitting,
            localisationFields,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCategoriesInputField }
                                    fullWidth={ true }
                                    label={ 'resources.subcategories.fields.category_id' }
                                    name='category_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

SubcategoriesCreateForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
        {
            maxLength: 325,
            name: 'description',
            required: true,
            type: 'textarea',
        },
    ],
};

SubcategoriesCreateForm.propTypes = {
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.category_id) {
                errors.category_id = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(SubcategoriesCreateForm);



// WEBPACK FOOTER //
// ./src/pages/subcategories/create/SubcategoriesCreateForm.js